import { FC } from 'react';
import { Box, BoxProps, forwardRef } from '@chakra-ui/react';

export type TagColor = 'white' | 'green' | 'yellow' | 'blue' | 'gray' | 'red' | 'orange' | 'transparent';

export type TagProps = Omit<BoxProps, 'backgroundColor'> & {
  label: string;
  backgroundColor?: TagColor;
};

const colorMap: Record<TagColor, string> = {
  white: 'white',
  green: 'green.400',
  yellow: 'yellow.400',
  blue: 'blue.400',
  gray: 'gray.400',
  red: 'red.400',
  orange: 'primary.500',
  transparent: 'transparent',
};

export const Tag: FC<TagProps> = forwardRef(({ label, backgroundColor = 'green', color = 'white', ...rest }, ref) => {
  return (
    <Box
      ref={ref}
      as="span"
      backgroundColor={colorMap[backgroundColor]}
      py={0.5}
      px={2}
      borderRadius="sm"
      color={colorMap[color as TagColor]}
      fontSize="xs"
      {...rest}
    >
      {label?.toUpperCase()}
    </Box>
  );
});
